import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Flex, Typography } from 'antd';

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';
import { useHomeAuthModal } from '../HomeAuthModalContext';

const { Title, Paragraph } = Typography;
const everywherePng = '/home/assets/everywhere.png';

const EverywhereSection = () => {
  const { openRegister } = useHomeAuthModal();
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__everywhere">
      <div
        className="home-page__everywhere-visual"
        aria-hidden
        style={{
          backgroundImage: `url(${everywherePng})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div className="home-page__section-frame">
        <Title level={2}>
          <FormattedMessage id={homeMessageId('everywhere.title')} />
        </Title>
        <Paragraph className="home-page__everywhere-side">
          <FormattedMessage id={homeMessageId('everywhere.sideText')} />
        </Paragraph>
        <Paragraph className="home-page__everywhere-text">
          <FormattedMessage id={homeMessageId('everywhere.text')} />
        </Paragraph>
        <Flex justify="center">
          <Button
            type="primary"
            className="btn-gradient btn-xl"
            onClick={openRegister}
          >
            <FormattedMessage id={homeMessageId('button.tryFree')} />
            <AiIcon name="btn-primary-circle-arrow-lg" />
          </Button>
        </Flex>
      </div>
    </section>
  );
};

export default EverywhereSection;
